import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import { type FitBoundsOptions, type LatLngBoundsExpression } from 'leaflet';

import type { SitePreviewExtended } from '@/api/fe-api/domain/entities/site';

// Default map boundaries: Germany
const defaultBounds: LatLngBoundsExpression = [
  [47.2701114, 5.8663153],
  [55.099161, 15.0419319],
];

const options: FitBoundsOptions = {
  padding: [50, 50],
};

export type MapBoundsProps = {
  sites: SitePreviewExtended[];
};

/**
 * Sets the starting map boundaries.
 *
 * Note: This component will only work as a child of `MapContainer` due to the `useMap` hook.
 */
export function MapBounds({ sites }: MapBoundsProps) {
  const map = useMap();

  useEffect(
    function () {
      if (sites.length === 0) {
        map.fitBounds(defaultBounds, options);
      } else if (sites.length === 1) {
        map.setView([sites[0].lat, sites[0].lng], 12);
      } else {
        map.fitBounds(
          sites.map((site) => [
            site.lat,
            site.lng,
          ]) satisfies LatLngBoundsExpression,
          options,
        );
      }
    },
    [map, sites],
  );

  return <></>;
}
